import { EVENTS } from "../../../js/constants";
import ProgressBar from "../progress-bar/progress-bar";

class Teaser {
  /**
   * @param {HTMLElement} element - The Teaser element
   */
  constructor(element) {
    this.element = element;
    this.config = {
      attributes: {
        id: "data-id",
      },
      classes: {
        progressBar: ".js-Teaser-progressBar",
      },
    };

    const id = element.getAttribute(this.config.attributes.id);
    const progressBarElement = element.querySelector(
      this.config.classes.progressBar
    );

    if (!id) {
      return;
    }

    this.progressBar = new ProgressBar(progressBarElement, id);

    this._onVisibilityChange = this._onVisibilityChange.bind(this);

    // Binds the visibility change event listener
    this.element.addEventListener(EVENTS.VISIBLE, this._onVisibilityChange);
  }

  /**
   * Handles visibility state changes
   */
  _onVisibilityChange() {
    this.progressBar.setVisible(true);
  }
}

export default Teaser;
